var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterest = function SvgInterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#interest_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.847 5.584 2.12 19.773h50.912L46.668 5.584H7.848Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.456 19.773v35.974h45.07V19.773H5.456Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.418 5.584H7.848L2.12 19.773h50.912L46.668 5.584h-8.273M5.456 19.773v35.492h45.02M50.526 19.773v23.055M50.526 55.264v-7.653",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.643 53.742h16.693V19.314l-6.346-6.98a2.504 2.504 0 0 0-3.666-.042l-6.68 7.022v34.428Z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.91,
    y: 36.031,
    width: 4.94,
    height: 4.94,
    rx: 0.435,
    fill: "#F3FCFF",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.473,
    y: 21.842,
    width: 5.042,
    height: 5.042,
    rx: 0.435,
    fill: "#F3FCFF",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.027,
    y: 36.031,
    width: 4.94,
    height: 4.94,
    rx: 0.435,
    fill: "#F3FCFF",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.55 50.104c0-.701.57-1.27 1.27-1.27h8.346c.701 0 1.27.569 1.27 1.27v1.757H22.55v-1.757ZM17.543 53.157c0-.7.568-1.269 1.27-1.269h18.361c.701 0 1.27.569 1.27 1.27v2.103h-20.9v-2.104Z",
    fill: "#CCC",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.223 37.56c0-.701.568-1.27 1.269-1.27H30.5c.7 0 1.269.569 1.269 1.27v11.323h-7.546V37.56Z",
    fill: "#F3FCFF",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.32,
    cy: 45.767,
    transform: "rotate(-15.42 52.32 45.767)",
    fill: "#EAFFE6",
    stroke: "#000",
    strokeWidth: 0.8,
    r: 17.403
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.92 38.86a.559.559 0 0 1 .79.013l1.026 1.06a.558.558 0 0 1-.013.79L47.09 52.952a.558.558 0 0 1-.79-.012l-1.025-1.06a.559.559 0 0 1 .013-.789L57.92 38.86Z",
    fill: "#8ADDFF",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.927,
    cy: 50.475,
    r: 2.568,
    transform: "rotate(45.924 56.927 50.475)",
    fill: "#8ADDFF",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.083,
    cy: 41.339,
    r: 2.568,
    transform: "rotate(45.924 48.083 41.339)",
    fill: "#8ADDFF",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "interest_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.167 .5)",
    d: "M0 0h72.222v65H0z"
  })))));
};
export default SvgInterest;